import AffiliatesQuestion from "./question/common/AffiliatesQuestion";
import ThirdPartyProcessorQuestion from "./question/common/ThirdPartyProcessorQuestion";
import PapersPublishedQuestion from "./question/common/PapersPublishedQuestion";
import CodeReferencesQuestion from "./question/common/CodeReferencesQuestion";
import {useState} from "react";
import {NavLink} from "react-router-dom";
import IsProjectCompleteQuestion from "./question/applicant/IsProjectCompleteQuestion";
import LastYearResearchQuestion from "./question/applicant/LastYearResearchQuestion";
import IntendToContinueUsingDataQuestion from "./question/applicant/IntendToContinueUsingDataQuestion";
import ResearchOutputVariablesQuestion from "./question/applicant/ResearchOutputVariablesQuestion";
import ResearchersInProjectQuestion from "./question/applicant/ResearchersInProjectQuestion";
import LegalChangesToInstitutionQuestion from "./question/applicant/LegalChangesToInstitutionQuestion";
import ProjectInstitute from "../model/ProjectInstitute";
import IsResearchInPublicInterestQuestion from "./question/applicant/IsResearchInPublicInterestQuestion";
import IsResearchSensitiveQuestion from "./question/applicant/IsResearchSensitiveQuestion";

interface ApplicantAnnualReportFormProps {
   projectInstitute: ProjectInstitute;
   isSaving: boolean;
   handleSubmit: Function;
}

const CONFIRMATION1 = `I am the Applicant PI of the research project identified above.`;
const CONFIRMATION2 = `I am aware of all research being undertaken for the research project identified above.`;
const CONFIRMATION3 = `The provisions of the relevant Material Transfer Agreement(s) (including any applicable amendments 
                  and updates) and the Annexes are being compiled with.`;
const CONFIRMATION4 = `The security measures set out here are in place for the research project identified above to 
                  protect the UK Biobank Materials`;
const CONFIRMATION5 = `I have disclosed the details of all open-source code repositories (e.g. GitHub) associated with 
                  this research project. I have read and understood the guidance on the use of code repositories, and I 
                  understand that any misuse of data could result in UK Biobank terminating access to data for this 
                  project`;

/**
 * Endpoint to save the report
 */
const SAVE_REPORT_URL = "/ams/api/v1/annual-report-ui/save-report";
/**
 * Endpoint to unlock a report
 */
const UNLOCK_REPORT_URL = "/ams/api/v1/annual-report-ui/unlock-report";
/**
 * Endpoint to approve a report
 */
const APPROVE_REPORT_URL = "/ams/api/v1/annual-report-ui/approve-report";

/**
 * Applicant annual report form.
 */
export default function ApplicantAnnualReportForm({
                                                     projectInstitute,
                                                     isSaving,
                                                     handleSubmit
                                                  }: ApplicantAnnualReportFormProps) {
   const [confirmation1, setConfirmation1] = useState(false);
   const [confirmation2, setConfirmation2] = useState(false);
   const [confirmation3, setConfirmation3] = useState(false);
   const [confirmation4, setConfirmation4] = useState(false);
   const [confirmation5, setConfirmation5] = useState(false);

   return (
      <form id="applicantAnnualReport" className="needs-validation"
            onSubmit={(e) => handleSubmit(e, projectInstitute.form)}>
         {/*Question area of the form*/}
         <div id="applicantAnnualReportQuestionArea" className="form-question-area">
            <IsProjectCompleteQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            <LastYearResearchQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            <IntendToContinueUsingDataQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            <IsResearchInPublicInterestQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            <IsResearchSensitiveQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            <PapersPublishedQuestion isLocked={projectInstitute.form.locked} form={projectInstitute.form}/>
            <CodeReferencesQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            <ResearchOutputVariablesQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            <ResearchersInProjectQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
            {!projectInstitute.isAcademic &&
               <AffiliatesQuestion isLocked={projectInstitute.form.locked} form={projectInstitute.form}/>}
            <ThirdPartyProcessorQuestion isLocked={projectInstitute.form.locked} form={projectInstitute.form}/>
            <LegalChangesToInstitutionQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
         </div>
         {/*Confirmation area of the form*/}
         <div id="applicantAnnualReportConfirmationArea" className="form-confirmation-area">
            {(!projectInstitute.form.locked) ? <>
                  <div id="applicantAnnualReportConfirmation1" className="form-check">
                     <input id="applicantAnnualReportConfirmation1Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation1(!confirmation1)}/>
                     <label id="applicantAnnualReportConfirmation1Label" className="form-check-label"
                            htmlFor="applicantAnnualReportConfirmation1Check">
                        {CONFIRMATION1}
                     </label>
                  </div>
                  <div id="applicantAnnualReportConfirmation2" className="form-check">
                     <input id="applicantAnnualReportConfirmation2Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation2(!confirmation2)}/>
                     <label id="applicantAnnualReportConfirmation2Label" className="form-check-label"
                            htmlFor="applicantAnnualReportConfirmation2Check">
                        {CONFIRMATION2}
                     </label>
                  </div>
                  <div id="applicantAnnualReportConfirmation3" className="form-check">
                     <input id="applicantAnnualReportConfirmation3Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation3(!confirmation3)}/>
                     <label id="applicantAnnualReportConfirmation3Label" className="form-check-label"
                            htmlFor="applicantAnnualReportConfirmation3Check">
                        {CONFIRMATION3}
                     </label>
                  </div>
                  <div id="applicantAnnualReportConfirmation4" className="form-check">
                     <input id="applicantAnnualReportConfirmation4Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation4(!confirmation4)}/>
                     <label id="applicantAnnualReportConfirmation4Label" className="form-check-label"
                            htmlFor="applicantAnnualReportConfirmation4Check">
                        {CONFIRMATION4}
                     </label>
                  </div>
                  <div id="applicantAnnualReportConfirmation5" className="form-check">
                     <input id="applicantAnnualReportConfirmation5Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation5(!confirmation5)}/>
                     <label id="applicantAnnualReportConfirmation5Label" className="form-check-label"
                            htmlFor="applicantAnnualReportConfirmation5Check">
                        {CONFIRMATION5}
                     </label>
                  </div>
                  <div id="applicantAnnualReportSaveArea" className="form-save-area">
                     <button id="applicantAnnualReportSubmitBtn" type="submit" className="btn btn-success"
                             formNoValidate disabled={!confirmation1 || !confirmation2 || !confirmation3
                        || !confirmation4 || !confirmation5 || isSaving}
                     >Submit
                     </button>
                     <button id="applicantAnnualReportSaveBtn" type="submit" className="btn btn-primary"
                             formNoValidate disabled={isSaving}>Save
                        Draft
                     </button>
                  </div>
               </>
               :
               <div id="applicantAnnualReportSaveArea" className="form-save-area">
                  <button id="applicantAnnualReportUnlockBtn" type="submit" className="btn btn-success"
                          formNoValidate disabled={isSaving}>
                     Unlock Report
                  </button>
                  <button id="applicantAnnualReportApproveBtn" type="submit" className="btn btn-primary"
                          formNoValidate disabled={isSaving}>
                     Approve Report
                  </button>
               </div>}
            <NavLink to="?page=annual-report" className="nav-link return-to-landing">
               <i className="bi bi-arrow-left-short"></i>Return to Annual Reports
            </NavLink>
         </div>
      </form>
   );
}
